// extracted by mini-css-extract-plugin
export var Paginator = "paginator-module--Paginator--2VSdq";
export var Paginator__control = "paginator-module--Paginator__control--1DA5R";
export var Paginator__control_active = "paginator-module--Paginator__control_active--3vlD3";
export var Paginator__control_nextPage = "paginator-module--Paginator__control_nextPage--3BDMS";